import { Controller } from "stimulus"
import Rails from '@rails/ujs'

export default class extends Controller {
  select(e) {
    e.preventDefault()
    const selected_id = parseInt(e.currentTarget.dataset.id)
    const field = document.getElementById("subscription_previous_subscriptions")

    let existing_ids = field.value.split(",").map((id) => parseInt(id))

    let selected_ids = new Set(existing_ids)
    selected_ids.add(selected_id)

    field.value = [...selected_ids].join(", ")

    Rails.fire(field.closest("form"), 'submit');
  }
}
